import Credentials from "next-auth/providers/credentials"
import type { NextAuthConfig } from "next-auth"

const KEYCLOAK_SERVER_URL = process.env.KEYCLOAK_CLIENT_URL;
const KEYCLOAK_URL = `${KEYCLOAK_SERVER_URL}/protocol/openid-connect/token`;
const CLIENT_ID = "logueoBack";
const GRANT_TYPE = "password";

export default {
    pages: {
        signIn: '/auth/login',
        signOut: '/auth/login',
        error: '/auth/error',
    },
    trustHost: true,
    providers: [
        Credentials({
            async authorize(credentials) {

                if (!credentials) {
                    return null;
                }
                const formDetails = {
                    client_id: `${CLIENT_ID}`,
                    grant_type: `${GRANT_TYPE}`,
                    username: `${credentials.username}`,
                    password: `${credentials.password}`,
                };
                const formBody = new URLSearchParams(formDetails).toString();
                try {
                    const response = await fetch(KEYCLOAK_URL, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: formBody,
                    });

                    const data = await response.json();

                    if (!response.ok) {
                        throw new Error(`Error en la autenticación: ${data.error_description || response.statusText}`);
                    }

                    const expiresAt = new Date();
                    expiresAt.setSeconds(expiresAt.getSeconds() + data.expires_in);

                    const user = { name: `${credentials.username}`, email: "email@example.com", accessToken: `${data?.access_token}`, expires: expiresAt.toISOString() }
                    return user;
                } catch (error) {
                    console.error("Error al autenticar con Keycloak:", error);
                    return null;
                }
            }

        },),
    ],
} satisfies NextAuthConfig